import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceThcPublicSafetyModel } from './types';
import substanceThcPublicSafetyItemValidator from './validators/item';

const substanceThcPublicSafetyValidator: ValidateJSModel<SubstanceThcPublicSafetyModel> = {
  UsedThc: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedThc && attributes?.UsedThc.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: substanceThcPublicSafetyItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceThcPublicSafetyValidator;
